export const state = function () {
  return {
    raw_available: [],
    selected: 0,
  }
}

export const mutations = {
  SELECT_BY_ID: function (state, pack_id) {
    state.selected = pack_id
  },
  SET_AVAILABLES: function (state, newavailable) {
    state.raw_available.splice(0, state.raw_available.length)

    newavailable.sort((a, b) => {
      return b.cost - a.cost
    })
    for (var i = newavailable.length - 1; i >= 0; i--)
      state.raw_available.push({
        ...newavailable[i],
        cost: Number(newavailable[i].cost),
        groovies: Number(newavailable[i].groovies),
      })
  },
}

export const actions = {
  FETCH: async function ({ commit }) {
    const packs = await this.$axios.$get("/wallet/pack/")

    commit("SET_AVAILABLES", packs)
  },
}

export const getters = {
  PURCHASE_PRICE: function (state, getters, rootState, rootGetters) {
    return rootGetters["payin/PURCHASE_AMOUNT"]
  },
  AVAILABLE: function (state, getters, rootState, rootGetters) {
    const ret = []
    let cost = 0

    if (rootGetters["payin/PURCHASE_TYPE"] === "sendtrack")
      cost = rootGetters["payin/MISSING_CREDITS"]
    else cost = 10
    if (cost) {
      cost = Math.max(cost, 10)
      for (var i = state.raw_available.length - 1; i >= 0; i--) {
        if (state.raw_available[i].cost > cost * 1.15)
          ret.push(state.raw_available[i])
      }
    }
    return ret
  },
  SELECTED_PACK_OBJ: function (state, getters) {
    if (getters.IS_SELECTED) {
      return state.raw_available.find((elem) => {
        return elem.id === state.selected
      })
    }
  },
  SELECTED_PERCENT: function (state, getters) {
    if (getters.IS_SELECTED) {
      const pack = getters["SELECTED_PACK_OBJ"]
      return Math.round((1 - pack.cost / pack.groovies) * 100)
    } else return 0
  },
  IS_SELECTED: function (state) {
    return state.selected > 0
  },
}
